import LegalPage from '../../components/common/LegalPage';

const SECTIONS = [
  {
    title: 'Information We Collect',
    body: `We collect information you provide directly to us, such as when you create an account, make a purchase, or contact us for support. This includes:

• Personal identifiers: name, email address, phone number, date of birth
• Billing and shipping addresses
• Payment information (processed securely by our payment partners — we do not store card numbers)
• Order history and preferences
• Communications you send us

We also collect certain information automatically when you use our platform, including IP address, browser type, device information, and pages visited through cookies and similar tracking technologies.`,
  },
  {
    title: 'How We Use Your Information',
    body: `We use the information we collect to:

• Process and fulfill your orders
• Send transactional emails (order confirmations, shipping updates)
• Provide customer support
• Personalize your shopping experience and product recommendations
• Send marketing communications (only with your consent)
• Improve our website and services
• Comply with legal obligations and resolve disputes
• Detect and prevent fraud`,
  },
  {
    title: 'Sharing of Information',
    body: `We do not sell, rent, or trade your personal information to third parties. We may share your information with:

• Logistics and shipping partners (to fulfill your orders)
• Payment processors (to process transactions securely)
• Cloud hosting and IT service providers
• Analytics providers (in anonymized, aggregated form)
• Legal authorities when required by law

All third parties are bound by confidentiality agreements and are prohibited from using your information for any purpose other than providing services to us.`,
  },
  {
    title: 'Cookies & Tracking Technologies',
    body: `We use cookies and similar technologies to enhance your experience, remember your preferences, and analyze site traffic. You can control cookies through your browser settings. Note that disabling cookies may affect the functionality of our website.

Types of cookies we use:
• Essential cookies: required for the website to function
• Preference cookies: remember your settings and preferences
• Analytics cookies: help us understand how visitors use our site
• Marketing cookies: used to deliver relevant advertisements`,
  },
  {
    title: 'Data Retention',
    body: `We retain your personal data for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data at any time by contacting us at privacy@bhadralok.com. Note that we may retain certain information as required by law or for legitimate business purposes.`,
  },
  {
    title: 'Your Rights',
    body: `You have the right to:

• Access the personal information we hold about you
• Correct inaccurate or incomplete information
• Request deletion of your personal data
• Opt out of marketing communications at any time
• Data portability — receive your data in a structured, machine-readable format
• Withdraw consent where processing is based on consent

To exercise any of these rights, contact us at privacy@bhadralok.com.`,
  },
  {
    title: 'Security',
    body: `We implement industry-standard security measures to protect your personal information, including SSL encryption, secure payment processing, access controls, and regular security audits. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.`,
  },
  {
    title: 'Children\'s Privacy',
    body: `Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children. If you believe we have inadvertently collected information from a child, please contact us immediately.`,
  },
  {
    title: 'Changes to This Policy',
    body: `We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of significant changes by email or through a prominent notice on our website. Your continued use of our services after changes become effective constitutes acceptance of the updated policy.`,
  },
  {
    title: 'Contact Us',
    body: `For any questions, concerns, or requests related to this Privacy Policy or your personal data, please contact our Privacy Team:

Email: privacy@bhadralok.com
Address: Bhadralok Studio, 12/3 College Street, North Kolkata, West Bengal — 700073
Phone: +91 98765 43210 (Mon–Sat, 10am–7pm IST)`,
  },
];

export default function PrivacyPolicy() {
  return (
    <LegalPage
      title="PRIVACY POLICY"
      label="Your Privacy Matters"
      lastUpdated="January 1, 2025"
      intro="At Bhadralok, we take your privacy seriously. This Privacy Policy explains how we collect, use, disclose, and protect your personal information when you use our website, mobile application, and services."
      sections={SECTIONS}
    />
  );
}
